$(function() {

    // Search Form
    $('#vos-demarches #searchform .submit').off('click').on('click', (e) => {

        e.preventDefault();

        $('#vos-demarches #search-results .error').removeClass('d-block');
        $('#vos-demarches #search-results .error').addClass('d-none');
        $('#vos-demarches #search-results .nocontent').removeClass('d-block');
        $('#vos-demarches #search-results .nocontent').addClass('d-none');

        if ($('#vos-demarches #searchform #search').val().length < 4) {
            $('#vos-demarches #search-results .error').removeClass('d-none');
            $('#vos-demarches #search-results .error').addClass('d-block');
            return false;
        }

        $('#vos-demarches #search-results .search-results-list').empty();

        let position = 0;
        $('#vos-demarches #vos-demarches-contenus .vos-demarches').each(function() {
            position = $(this).text().toLowerCase().search($('#vos-demarches #searchform #search').val().toLowerCase());
            if (position > -1) {
                $(this).clone().appendTo('#vos-demarches #search-results .search-results-list');
            }
        });

        if(!/[\S]/.test($('#vos-demarches #search-results .search-results-list').html())) {
            $('#vos-demarches #search-results .nocontent').removeClass('d-none');
            $('#vos-demarches #search-results .nocontent').addClass('d-block');
        } else {
            $('#vos-demarches #search-results .search-results-list .vos-demarches').each(function() {
                $(this).removeClass('collapse');
            });
        }


    });

    // Category selection in desktop mode
    $('#vos-demarches #vos-demarches-categories .list-group .list-group-item .btn').off('click').on('click', (e) => {

        let el = '#vos-demarches #vos-demarches-categories .list-group .list-group-item .btn#'+e.target.id;
        let category = e.target.id;

        if (e.target.classList.contains("active")) {
            e.stopPropagation();
            return false;
        }

        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item .btn').removeClass('active');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item .btn').attr('data-bs-toggle','collapse');
        $(el).addClass('active');
        $(el).removeAttr('data-bs-toggle');

        // Dealing with Category Selection in mobile mode
        let mobile_el = '#vos-demarches #vos-demarches-categories .dropdown .dropdown-item#'+category;
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item').removeClass('active');
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item').removeAttr('aria-current');
        $(mobile_el).addClass('active');
        $(mobile_el).attr('aria-current',true);
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-toggle').text($(mobile_el).text());

    });

    // Category selection in mobile mode
    $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item').off('click').on('click', (e) => {

        let el = '#vos-demarches #vos-demarches-categories .dropdown .dropdown-item#'+e.target.id;
        let category = e.target.id;

        if (e.target.classList.contains("active")) {
            e.stopPropagation();
            return false;
        }

        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item').removeClass('active');
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item').removeAttr('aria-current');
        $(el).addClass('active');
        $(el).attr('aria-current',true);
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-toggle').text($(el).text());

        // Dealing with Category Selection in desktop mode
        let desktop_el = '#vos-demarches #vos-demarches-categories .list-group .list-group-item .btn#'+category;
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item .btn').removeClass('active');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item .btn').attr('data-bs-toggle','collapse');
        $(desktop_el).addClass('active');
        $(desktop_el).removeAttr('data-bs-toggle');

    });

    let _default = true;
    let _url = new URL(window.location.href);
    _url.href = _url.href.replace(_url.hash, '');
    let _category = _url.searchParams.get('categorie');


    if (_category !== null) {


        if ($('#vos-demarches #vos-demarches-contenus .vos-demarches#'+_category).length > 0) {
            _default = false;
        }
    }


    if (!_default) {

        // Category Desktop
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item.category-'+_category).addClass('active');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item.category-'+_category+' .btn').removeClass('collapsed');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item.category-'+_category+' .btn').addClass('active');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item.category-'+_category+' .btn').removeAttr('data-bs-toggle');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item.category-'+_category+' .btn').attr('aria-expanded', true);
        // Category Mobile
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item.category-'+_category).addClass('active');
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item.category-'+_category).attr('aria-current',true);
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-toggle').text($('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item.category-'+_category).text());

        $('#vos-demarches #vos-demarches-contenus .vos-demarches#'+_category).addClass('show');

    } else {
        // By default selecting the first
        // Category Desktop
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item:first').addClass('active');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item:first .btn').removeClass('collapsed');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item:first .btn').addClass('active');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item:first .btn').removeAttr('data-bs-toggle');
        $('#vos-demarches #vos-demarches-categories .list-group .list-group-item:first .btn').attr('aria-expanded', true);
        // Category Mobile
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item:first').addClass('active');
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item:first').attr('aria-current',true);
        $('#vos-demarches #vos-demarches-categories .dropdown .dropdown-toggle').text($('#vos-demarches #vos-demarches-categories .dropdown .dropdown-item:first').text());

        $('#vos-demarches #vos-demarches-contenus .vos-demarches:first').addClass('show');
    }




});

